import apiShopkeeperApp from '@/api/shopkeeperAppApi';

export default {
  getWebhooksShopkeeperApp(
    { rootGetters },
    { active = true, currentPage = 1 }
  ) {
    let queryParams = `?page=${currentPage || 1}`;
    queryParams += `&active=${active || true}`;

    return apiShopkeeperApp.get(`/webhook/${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};